import { PopupMessageDefaultConfig } from "sb-resp-ui";
import { getPopupShowConfig } from "../getPopupShowConfig";
import { getPopupMessageConfig } from "../getPopupMessageConfig";
export const getPopupConfigs = (context, config, legacyCallback) => {
    var popupShowConfig = {}, popupMessageConfig = Object.assign({}, PopupMessageDefaultConfig);
    if (config) {
        popupShowConfig = getPopupShowConfig(config, legacyCallback);
        popupMessageConfig = getPopupMessageConfig(config, context);
    }
    return { popupShowConfig, popupMessageConfig };
};
//# sourceMappingURL=getPopupConfig.js.map